import * as React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle } from 'assets/styles/globalStyles';
import { theme } from 'assets/styles/theme';
import { HeaderComponent } from 'components/Navigation/Navigation';
import { FooterComponent } from 'components/Footer/Footer';

export const MainTemplate = ({ children, location }) => {
  const isHomepage = location.pathname === '/';
  return (
    <>
      <GlobalStyle />
      <ThemeProvider theme={theme}>
        <HeaderComponent />
        <main role="main">
          {isHomepage ? (
            children
          ) : (
            <div className="row">
              {children}
            </div>
          )}
        </main>
        <FooterComponent />
      </ThemeProvider>
    </>
  );
};

MainTemplate.propTypes = {
  children: PropTypes.node.isRequired,
};
